import { useRef, memo, useMemo } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { MemberMultiSelectDropdown } from '../common';

const AddNotificationRecipients = ({
  teamMembersList,
  recipientUsers,
  handleAddRecipients,
}) => {
  const filterOutExistingUsers = (users, existingRecipients) => {
    const recipientUserIds = new Set(
      existingRecipients.map((ru) => ru.userId?._id)
    );
    return users.filter((user) => !recipientUserIds.has(user.userId));
  };

  const supervisorsAndManagersList = useMemo(
    () =>
      teamMembersList?.length
        ? teamMembersList.filter(
            (member) =>
              member.typeName === 'manager' ||
              member.typeName === 'supervisor' ||
              member.typeName === 'account owner'
          )
        : [],
    [teamMembersList]
  );

  const memberOptions = useMemo(
    () => filterOutExistingUsers(supervisorsAndManagersList, recipientUsers),
    [supervisorsAndManagersList, recipientUsers]
  );

  const existingTeamMembers = [];
  const selectRecipientInputRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && event.shiftKey === false) {
      event.preventDefault();
    }
  };

  const validationSchema = Yup.object().shape({
    addExistingTeamMembers: Yup.array(),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={{
        members: existingTeamMembers,
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { resetForm }) => {
        handleAddRecipients(values);
        resetForm();
        // Clear input values
        selectRecipientInputRef.current.select.clearValue();
      }}
    >
      {(formikprops) => (
        <Form
          onSubmit={formikprops.handleSubmit}
          onKeyDown={(e) => {
            handleKeyDown(e);
          }}
        >
          <section>
            <MemberMultiSelectDropdown
              id="selectRecipientInputRef"
              name="members"
              labelText="Add user to recipients list"
              fromArray={memberOptions}
              formProps={formikprops}
              innerRef={selectRecipientInputRef}
              requiredValueAs="userId"
            />
          </section>

          <div className="d-flex align-items-center mb-5">
            <Button
              type="submit"
              variant="outline-primary"
              size="sm"
              disabled={formikprops.values.members.length < 1}
            >
              Add to Recipients List
              {formikprops.isSubmitting && (
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

AddNotificationRecipients.propTypes = {
  teamMembersList: PropTypes.array,
  recipientUsers: PropTypes.array,
  handleAddRecipients: PropTypes.func,
};

export default memo(AddNotificationRecipients);
